import React from 'react'
import { Route, IndexRoute } from 'react-router'

import * as Pages from '../containers'
import * as Components from '../components'
export default (
  <Route>
    <Route path="login" component={Pages.LoginPage} />
    <Route path="register" component={Pages.RegisterPage} />
    <Route path="wechat" component={Pages.WeChatPage} />
    <Route path="forget" component={Pages.ForgetPage} />
    <Route path="portal" component={Pages.DefaultPage} />
    <Route path="test" component={Pages.TestPage} />
    <Route path="/platform/:menuurl" component={Components.DynamicView} />
    <Route path="meta">
      <Route path=":billtype/:billno" component={Components.DynamicView} />
      <Route path=":billtype/:billno/:billid" component={Components.DynamicView} />
    </Route>
    <Route path="*" component={Pages.ErrorNotFoundPage} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/common/redux/routes.jsx